module.exports = {
          srcSet: __webpack_public_path__ + "images/1976-bf55b5a8fad2da88dc5965d8dd8f9942-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1976-278015261ff3ddd5552357c071973f0d-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1976-bf55b5a8fad2da88dc5965d8dd8f9942-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1976-278015261ff3ddd5552357c071973f0d-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1976-bf55b5a8fad2da88dc5965d8dd8f9942-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1976-bf55b5a8fad2da88dc5965d8dd8f9942-320.jpg"},
          
          width: 320,
          height: 251
        }